import { useDispatch } from "react-redux"
import Box from "../../../../components/Box"
import CustomNumberInput from "../../../../components/CustomNumberInput"
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect"
import CustomTextInput from "../../../../components/CustomTextInput"
import { storeFastFirm } from "../../../../redux/reducers/authSlice"
import { CompanyService } from "../../../../services/CompanyService"
import { ConstantService } from "../../../../services/ConstantService"
import { KTCard } from "../../../../_metronic/helpers/components/KTCard"
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody"

interface Props {
    generalInformationRef: any
    ledgerNo: string | undefined
    setLedgerNo: React.Dispatch<React.SetStateAction<string | undefined>>
    antrepoDeclarationNo: string | undefined
    setAntrepoDeclarationNo: React.Dispatch<React.SetStateAction<string | undefined>>
    antrepoDeclarationDate: string | undefined
    setAntrepoDeclarationDate: React.Dispatch<React.SetStateAction<string | undefined>>
    goodsAmount: string | undefined
    setGoodsAmount: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedGoodsAmountCurrencyType: CustomSingleSelectModel | undefined
    setSelectedGoodsAmountCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    guaranteeAmount: string | undefined
    setGuaranteeAmount: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedGuaranteeAmountCurrencyType: CustomSingleSelectModel | undefined
    setSelectedGuaranteeAmountCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSenderFirm: CustomSingleSelectModel | undefined
    receiptNo: string | undefined
    setReceiptNo: React.Dispatch<React.SetStateAction<string | undefined>>
    receiptDate: string | undefined
    setReceiptDate: React.Dispatch<React.SetStateAction<string | undefined>>
    setSelectedSenderFirm: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isPartial: boolean
    declarationPotQuantity: string | undefined
    setDeclarationPotQuantity: React.Dispatch<React.SetStateAction<string | undefined>>
    declarationPotWeight: string | undefined
    setDeclarationPotWeight: React.Dispatch<React.SetStateAction<string | undefined>>
    defaultAntrepoDeclarationNo: string
    isDisabledFromLock: boolean
}

const GeneralInformation = ({
    generalInformationRef,
    ledgerNo,
    setLedgerNo,
    antrepoDeclarationNo,
    setAntrepoDeclarationNo,
    antrepoDeclarationDate,
    setAntrepoDeclarationDate,
    goodsAmount,
    setGoodsAmount,
    selectedGoodsAmountCurrencyType,
    setSelectedGoodsAmountCurrencyType,
    guaranteeAmount,
    selectedGuaranteeAmountCurrencyType,
    setGuaranteeAmount,
    setSelectedGuaranteeAmountCurrencyType,
    selectedSenderFirm,
    receiptNo,
    setReceiptNo,
    receiptDate,
    setReceiptDate,
    setSelectedSenderFirm,
    isPartial,
    declarationPotQuantity,
    declarationPotWeight,
    setDeclarationPotQuantity,
    setDeclarationPotWeight,
    defaultAntrepoDeclarationNo,
    isDisabledFromLock
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={generalInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Defter No</label>
                            <input tabIndex={0} style={{ border: '1px solid #F1F1F4' }} value={ledgerNo} onChange={(e) => setLedgerNo(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Beyan Kap Adet</label>
                            <CustomNumberInput isDisabled={!isPartial || isDisabledFromLock} tabIndex={4} value={declarationPotQuantity} setValue={setDeclarationPotQuantity} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Makbuz No</label>
                            <CustomTextInput isDisabled={isDisabledFromLock} tabIndex={8} value={receiptNo} setValue={setReceiptNo} />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Çıkış Antrepo Beyan No</label>
                            <input disabled={isDisabledFromLock} tabIndex={1} style={{ border: '1px solid #F1F1F4' }} value={antrepoDeclarationNo} onChange={(e) => setAntrepoDeclarationNo(e.target.value.startsWith(defaultAntrepoDeclarationNo) ? e.target.value : defaultAntrepoDeclarationNo)} type="text" className="form-control form-control-solid" />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Beyan Kap Ağırlık (Kg)</label>
                            <CustomNumberInput isDisabled={!isPartial || isDisabledFromLock} tabIndex={5} value={declarationPotWeight} setValue={setDeclarationPotWeight} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Makbuz Tarihi</label>
                            <input disabled={isDisabledFromLock} tabIndex={9} style={{ border: '1px solid #F1F1F4' }} value={receiptDate} onChange={(e) => setReceiptDate(e.target.value)} type="datetime-local" className="form-control form-control-solid" />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Çıkış Antrepo Beyan Tarihi</label>
                            <input disabled={isDisabledFromLock} tabIndex={2} style={{ border: '1px solid #F1F1F4' }} value={antrepoDeclarationDate} onChange={(e) => setAntrepoDeclarationDate(e.target.value)} type="datetime-local" className="form-control form-control-solid" />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Mal Değeri</label>

                            <Box flexDirection="row">
                                <Box mr="15px" flexGrow={1} justifyContent="center">
                                    <CustomNumberInput tabIndex={!isPartial ? undefined : 6} isDisabled={!isPartial || isDisabledFromLock} value={goodsAmount} setValue={setGoodsAmount} />
                                </Box>
                                <Box justifyContent="center">
                                    <CustomSingleSelect
                                        disabled
                                        selectedValue={selectedGoodsAmountCurrencyType}
                                        onChange={setSelectedGoodsAmountCurrencyType}
                                        onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                        labelName='additionalValue1'
                                        valueName='constantId'
                                    />
                                </Box>
                            </Box>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            &nbsp;
                        </div>
                        {/* <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Gönderici Firma</label>
                            <CustomSingleSelect
                                tabIndex={3}
                                selectedValue={selectedSenderFirm}
                                onChange={setSelectedSenderFirm}
                                insertable={{
                                    tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedSenderFirm?.value,
                                            isSenderFirm: true,
                                            onSubmit: async (response) => {
                                                setSelectedSenderFirm({ label: response.name, value: response.companyId })
                                            },
                                        }))
                                    }
                                }}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isSenderFirm: true }),
                                    () => CompanyService.getCompanyList({ isCustomer: true }),
                                ]}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div> */}

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Teminat Bedeli</label>

                            <Box flexDirection="row">
                                <Box mr="15px" flexGrow={1} justifyContent="center">
                                    <CustomNumberInput tabIndex={!isPartial ? undefined : 7} isDisabled={!isPartial || isDisabledFromLock} value={guaranteeAmount} setValue={setGuaranteeAmount} />
                                </Box>
                                <Box justifyContent="center">
                                    <CustomSingleSelect
                                        disabled
                                        selectedValue={selectedGuaranteeAmountCurrencyType}
                                        onChange={setSelectedGuaranteeAmountCurrencyType}
                                        onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                        labelName='additionalValue1'
                                        valueName='constantId'
                                    />
                                </Box>
                            </Box>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div >
    )
}

export default GeneralInformation;